import { render, staticRenderFns } from "./AddPPage.vue?vue&type=template&id=0de76f2f&scoped=true&"
import script from "./AddPPage.vue?vue&type=script&lang=js&"
export * from "./AddPPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPPage.vue?vue&type=style&index=0&id=0de76f2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de76f2f",
  null
  
)

export default component.exports